export function transformedTimezoneForMoment(timezone) {
    return timezone === 'Europe/Kyiv' ? 'Europe/Kiev' : timezone;
}